import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  title: string;
}

export function DeleteFavoriteSuccessToast(props: Props) {
  const {
    id,
    title,
  } = props

  const polyglot = usePolyglot()

  const body = polyglot.t(
    "toasts.delete_favorite_success.body",
    { title },
  )

  return (
    <Toast
      stylePreset="success"
      body={body}
      id={id}
    />
  )
}
